export default {"src":"/login-app/[GIT_HASH]/_next/static/media/collapse_fullscreen.9438c6df.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};